export default __webpack_public_path__ + "static/media/IMG_017.e5c039e4.jpg";